<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 2
      h1 Origen, tipos y clasificación de los aditivos

    .row.justify-content-center.align-items-center.mb-5
      .col-12.col-lg-5.mb-lg-0.mb-3(data-aos="flip-left")
        figure
          img(src='@/assets/curso/temas/tema_2/img_1.png', class="img-fluid")
      .col-12.col-lg-7
        p.mb-3(data-aos="zoom-in-right") Los aditivos se clasifican en naturales y sintéticos, y ambos presentan diversos niveles de toxicidad. Su función es impedir cambios químicos, estabilizar características físicas y modificar propiedades organolépticas. 
        .tarjeta.color-secundario-5.p-3.rounded-0.mb-0(data-aos="zoom-in-right")
          .row.justify-content-center.align-items-center.mb-0
            .col-lg-1.d-lg-block.d-none
              figure
                img(src='@/assets/curso/temas/tema_2/img_2.png', class="img-fluid")
            .col-12.col-lg-11.mb-0
              p.mb-0 Para la conservación, se mantienen métodos tradicionales como el ahumado y el salado, junto con procesos modernos como la pasteurización. Actualmente, la industria emplea más de 4.000 aditivos para satisfacer la demanda de alimentos sanos, destacando los de origen natural por su mayor nivel de inocuidad.

    Separador

    #t_2_1.titulo-segundo.color-primario
      .h2(data-aos="fade-right") 2.1 Origen y tipos
    .mb-0
    
    p.mb-3(data-aos="zoom-in-right") Según su procedencia, los aditivos pueden ser de origen natural o artificial. Los aditivos naturales son extraídos directamente de plantas, semillas, frutas o algas, o provienen de modificaciones controladas de compuestos naturales; mientras que los artificiales son producidos por síntesis química y requieren evaluaciones más rigurosas de inocuidad. 
    
    .bg_img_4.mb-3
      .row.d-flex.align-items-stretch.justify-content-center.mb-0 
        .col-12.col-md-6.col-lg-3.col-xl-3.d-flex.mb-3.mb-xl-0.mb-3(data-aos="flip-left")
          .w-100.d-flex.flex-column
            .tarjeta--blanca-2.p-3.h-100
              .row.justify-content-center.align-items-center.mb-0.p-0
                .col-6.col-lg-4.mb-3
                  figure
                    img(src="@/assets/curso/temas/tema_2/img_4.svg", class="img-fluid")
                .col-12.col-lg-12
                  h6.text-white.text-center.bg-color-primario-20.text-center.fw-bold.p-3 Aditivos naturales de origen vegetal
                  p.mb-3 Extraídos de vegetales y partes de plantas como semillas, frutas y algas marinas.
                  p.mb-0 <B>Ejemplos:</B> cúrcuma, ácido cítrico, ácido tartárico y agar, entre otros.
        .col-12.col-md-6.col-lg-3.col-xl-3.d-flex.mb-3.mb-xl-0.mb-3(data-aos="flip-left")
          .w-100.d-flex.flex-column
            .tarjeta--blanca-2.p-3.h-100
              .row.justify-content-center.align-items-center.mb-0.p-0
                .col-6.col-lg-4.mb-3
                  figure
                    img(src="@/assets/curso/temas/tema_2/img_5.svg", class="img-fluid")
                .col-12.col-lg-12
                  h6.text-white.text-center.bg-color-primario-20.text-center.fw-bold.p-3 Aditivos naturales de biosíntesis 
                  p.mb-3 Obtenidos a partir de modificaciones a sustancias de origen natural.
                  p.mb-0 <B>Ejemplos:</B> emulgentes (derivados de aceites vegetales y ácidos orgánicos) y espesantes como almidones y celulosa.
        .col-12.col-md-6.col-lg-3.col-xl-3.d-flex.mb-3.mb-xl-0.mb-3(data-aos="flip-left")
          .w-100.d-flex.flex-column
            .tarjeta--blanca-2.p-3.h-100
              .row.justify-content-center.align-items-center.mb-0.p-0
                .col-6.col-lg-4.mb-3
                  figure
                    img(src="@/assets/curso/temas/tema_2/img_6.svg", class="img-fluid")
                .col-12.col-lg-12
                  h6.text-white.text-center.bg-color-primario-20.text-center.fw-bold.p-3 Aditivos artificiales 
                  p.mb-3 Creados en laboratorios químicos. No se encuentran en la naturaleza. Se usan principalmente en alimentos ultraprocesados.
                  p.mb-0 <B>Ejemplos:</B> ácido benzoico, lactato de amonio y tartrazina.
        .col-12.col-md-6.col-lg-3.col-xl-3.d-flex.mb-3.mb-xl-0.mb-3(data-aos="flip-left")
          figure
            img(src="@/assets/curso/temas/tema_2/img_7.png", class="img-fluid")

      .tarjeta--bg-img.color-primario-5.rounded-3.p-0.mb-4.overflow-hidden(data-aos="zoom-in-right")
        .row.justify-content-center.align-items-center.mb-0.h-100
          .col-12.col-lg-9.p-4
            p.mb-0 Los aditivos provienen de tres fuentes principales que determinan factores como su toxicidad, valor comercial y disponibilidad. Además, existen aditivos de origen animal que se utilizan frecuentemente en la industria alimentaria. Por ejemplo, el ácido carmínico se obtiene mediante el procesamiento de una especie de insecto, mientras que la gelatina se extrae de pieles, tejidos, ligamentos, huesos y pezuñas de animales como vacunos, porcinos, equinos, aves de corral y pescados.
          .col-12.col-lg-3.mb-lg-0.mb-3.p-0.align-self-stretch.d-none.d-lg-block
            figure.p-0.m-0.h-100
              img(src="@/assets/curso/temas/tema_2/img_8.png" class="img-fluid w-100 h-100 object-fit-cover").p-0

    Separador

    .bg_img_5.mb-3

      #t_2_2.titulo-segundo.color-primario
        .h2(data-aos="fade-right") 2.2 Clasificación funcional
      .mb-0
      
      .row.justify-content-center.align-items-center.mb-5
        .col-12.col-lg-3.mb-lg-0.mb-3(data-aos="flip-left")
          figure
            img(src='@/assets/curso/temas/tema_2/img_10.png', class="img-fluid")
        .col-12.col-lg-8(data-aos="zoom-in-right")
          p.mb-3 El <em>Codex Alimentarius</em> de la Organización Mundial de la Salud (OMS, 2025) clasifica los aditivos de acuerdo con su función tecnológica en categorías como colorantes, conservantes, antioxidantes, estabilizantes, acidulantes, edulcorantes y potenciadores del sabor, lo que facilita su correcta selección y aplicación. 
          p.mb-0 Cada grupo cumple una función específica que impacta la estabilidad, apariencia, sabor o vida útil del alimento.
        .col-10.col-lg-1.d-lg-block.d-none.mb-lg-0.mb-3(data-aos="flip-left")
          figure
            img(src='@/assets/curso/temas/tema_2/img_11.png', class="img-fluid")
     
      .titulo-sexto.color-acento-botones(data-aos="zoom-in-right")
        h5 Tabla 1.
        |  Clasificación funcional de los aditivos alimentarios
      .tabla-a.mb-5(data-aos="flip-left")
        table
          caption 
            p Nota. Adaptado del <em>Codex Alimentarius</em> de la Organización Mundial de la Salud (OMS, 2025).
          thead
            tr
              th Tipo de aditivo
              th Función tecnológica
              th Ejemplo
          tbody
            tr
              td.text-start Colorantes.
              td.text-start Brindan más color al producto, mejoran el aspecto visual de los alimentos.
              td.text-start Tartrazina.
            tr
              td.text-start Conservantes.
              td.text-start Se emplean para evitar el deterioro de los alimentos a causa de los microorganismos.
              td.text-start Sulfito de sodio.
            tr
              td.text-start Antioxidantes.
              td.text-start Evitan que los alimentos tomen mal aspecto y sabor por efecto de la oxidación.
              td.text-start Ácido ascórbico (Vitamina C).
            tr
              td.text-start Edulcorantes.
              td.text-start Proporcionan un sabor dulce a los productos sustituyendo el uso de azúcares.
              td.text-start Aspartame.
            tr
              td.text-start Estabilizantes.
              td.text-start Alteran la textura y composición de los alimentos.
              td.text-start Goma de algarrobo.
            tr
              td.text-start Reguladores de pH.
              td.text-start Regulan el nivel de acidez de los alimentos cambiando su sabor.
              td.text-start Ácido cítrico.
            tr
              td.text-start Potenciadores de sabor.
              td.text-start Incrementan la percepción del sabor de los alimentos sin que tengan uno propio. 
              td.text-start Glutamato de sodio.
    
    .row.justify-content-center.align-items-center(data-aos="zoom-in-right")
      .col-12.col-lg-10.mb-5
        .div.tarjeta--bg-img.color-primario-20.rounded-3.p-0.mb-5.overflow-hidden
          .row.justify-content-around.align-items-center.mb-0.h-100
            .col-12.col-lg-2.mb-lg-0.mb-3.p-0.align-self-stretch.d-none.d-lg-block
              figure.p-0.m-0.h-100
                img(src="@/assets/curso/temas/tema_1/img_6.svg" class="img-fluid w-100 h-100 object-fit-cover").p-0
            .col-12.col-lg-10.p-4.pe-5
              .row.justify-content-between.align-items-center
                .col.mb-5.mb-sm-0
                  h4.mb-1 Para conocer más sobre la funcionalidad de los aditivos, ingrese al siguiente enlace de video: 
                .col-sm-auto
                  a.boton.color-acento-botones(href="https://www.youtube.com/watch?v=aff6QP3AnVo" target="_blank")
                    span Enlace
                    i.fas.fa-link.me-2

</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
